import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  List,
  TextField,
  InputAdornment,
  Avatar,
  Button,
} from "@material-ui/core";
import CommentItem from "./comment-item.component";
import { selectCurrentReport } from "../../redux/reports/report.selector";
import { selectCurrentUser, selectUsers } from "../../redux/user/user.selector";
import { createCommentStart } from "../../redux/comments/comment.actions";

const Comments = ({
  comments,
  currentUser,
  currentReport,
  createComment,
  users,
}) => {
  const [newComment, setNewComment] = useState("");
  return (
    <div className={"comments"}>
      <TextField
        label="Neuer Kommentar:"
        fullWidth
        multiline
        variant="outlined"
        value={newComment}
        onChange={(evt) => setNewComment(evt.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Avatar />
            </InputAdornment>
          ),
        }}
        inputProps={{
          maxLength: 1000,
        }}
      />
      <Button
        variant="contained"
        style={{ marginTop: 16 }}
        onClick={() => {
          createComment({
            erstellt: new Date(),
            kommentar: newComment,
            reportId: currentReport.id,
            userId: currentUser.id,
          });
          setNewComment("");
        }}
      >
        Kommentieren
      </Button>
      <List>
        {comments
          .sort((a, b) => a.erstellt.seconds - b.erstellt.seconds)
          .map((comment) => {
            return (
              <CommentItem
                comment={comment}
                key={comment.id}
                author={users.find((user) => user.id === comment.userId)}
              />
            );
          })}
      </List>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  currentReport: selectCurrentReport,
  users: selectUsers,
});

const mapDispatchToProps = (dispatch) => ({
  createComment: (comment) => dispatch(createCommentStart(comment)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Comments);
